module.exports = __webpack_public_path__ + "static/media/homebg1.c150e6c7.png";